export { default as default } from "./createStreamingWorkerFunctionInBrowser.js";
